import React, { useState } from 'react';
import FullCalendar from '@fullcalendar/react'; // Main FullCalendar component
import dayGridPlugin from '@fullcalendar/daygrid'; // Month view plugin
import './EventCalendar.css';
import { events } from "../content"; // Import list of events from content.js

const EventCalendar = () => {
  const [selectedEvent, setSelectedEvent] = useState(null); // Stores event clicked

  return (
    <div style={{ display: 'flex', gap: '2rem', padding: '2rem' }}>
      
      {/* Calendar Section */}
      <div style={{ flex: 2 }}>
        <FullCalendar
          plugins={[dayGridPlugin]} // Use month grid view
          initialView="dayGridMonth"
          events={events} // List of events
          height="auto"
          eventClick={(info) => {
            // Show event details when clicked
            setSelectedEvent({
              title: info.event.title,
              date: info.event.startStr,
              location: info.event.extendedProps.location,
              time: info.event.extendedProps.time,
              description: info.event.extendedProps.description,
            });
          }}
        />
      </div>

      {/* Event Details Panel */}
      <div
        style={{
          flex: 1,
          border: '1px solid #ddd',
          padding: '1rem',
          borderRadius: '8px',
          backgroundColor: '#f9f9f9',
          minHeight: '200px',
        }}
      >
        {selectedEvent ? (
          <>
            <h2>{selectedEvent.title}</h2>
            <p><strong>Time:</strong> {selectedEvent.time}</p>
            <p><strong>Location:</strong> {selectedEvent.location}</p>
            <p><strong>Details:</strong> {selectedEvent.description}</p>
          </>
        ) : (
          <p>Select an event to see details</p>
        )}
      </div>
    </div>
  );
};

export default EventCalendar;
